import axios, { AxiosError } from 'axios';
import qs from 'qs';

interface MyApiError {
  error: {
    code: string;
    message: string;
    stackTraceMessage: string;
  };
}

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  paramsSerializer: (params) => {
    return qs.stringify(params, { arrayFormat: 'repeat' });
  },
});

axiosInstance.interceptors.request.use(
  async (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (err: AxiosError<MyApiError>) => {
    if (err.response?.status === 401 && err.config) {
      localStorage.removeItem('jwt_access_token');
    }
    throw err;
  },
);

export default axiosInstance;
